module.exports = __webpack_public_path__ + "img/sandbox-2.b20e3919.png";